/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_Filter_AllInputs */

const en_tasks_filter_all = /** @type {(inputs: Tasks_Filter_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All`)
};

const pt_br2_tasks_filter_all = /** @type {(inputs: Tasks_Filter_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos`)
};

/**
* | output |
* | --- |
* | "All" |
*
* @param {Tasks_Filter_AllInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const tasks_filter_all = /** @type {((inputs?: Tasks_Filter_AllInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Filter_AllInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_filter_all(inputs)
	return pt_br2_tasks_filter_all(inputs)
});